import { ContactType } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';

export class ContactInsuranceModel extends Model {
  public Type!: ContactType;
  public Name!: string;
  public Value!: string;

  constructor(type?: ContactType, name?: string) {
    super();
    if (type != undefined) this.Type = type;
    if (name) this.Name = name;
    this.Value = '';
  }
}
